import {
  FETCH_FUNCTION_TEMPLATES_FOR_TEMPLATE_ID_ERROR,
  FETCH_FUNCTION_TEMPLATES_FOR_TEMPLATE_ID_REQUEST,
  FETCH_FUNCTION_TEMPLATES_FOR_TEMPLATE_ID_SUCCESS,
} from "../actions";

import { SForTemplateId } from "./types";
import { FunctionTemplatesActions } from "../actionCreators";

const initialState: SForTemplateId = {
  isFetching: false,
  functionTemplates: undefined,
};

const forTemplateIdReducer = (
  state = initialState,
  action: FunctionTemplatesActions
): SForTemplateId => {
  switch (action.type) {
    case FETCH_FUNCTION_TEMPLATES_FOR_TEMPLATE_ID_REQUEST:
      return {
        ...state,
        isFetching: true,
      };

    case FETCH_FUNCTION_TEMPLATES_FOR_TEMPLATE_ID_SUCCESS:
      // tenhle lint problem zmizí s ts immer
      // eslint-disable-next-line
      const { functionTemplates } = action.payload;

      return {
        ...state,
        functionTemplates,
        isFetching: false,
      };

    case FETCH_FUNCTION_TEMPLATES_FOR_TEMPLATE_ID_ERROR:
      return {
        ...state,
        isFetching: false,
      };

    default:
      return state;
  }
};

export default forTemplateIdReducer;
